import { useIntl } from 'react-intl'

export const CurrentLocale = () => {
  const { formatMessage, locale } = useIntl()

  // @ts-ignore
  global.n = value => {
    const formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: 'EUR',
    })
    return formatter.format(value)
  }

  // @ts-ignore
  // `values` (optionnel) permet l'interpolation ICU : t({ id }, { count: 3 }).
  global.t = (args, values) => {
    return formatMessage({ ...args, defaultMessage: ' ' }, values)
  }

  // @ts-ignore
  global.currentLocale = locale

  return null
}
